module.exports = __webpack_public_path__ + "static/media/additional.6651b199.svg";